import { notification } from 'antd'
import store from 'store'
import i18n from 'i18n'
import orgChartDB from 'libs/DB/orgChartDB'

import { errorBase, openloadingAni } from 'utils/ui'

import { store as reduxStore } from 'index'
import { getEnvParam, setEnvParam, removeEnvParam, setTempEnvParam, getTempEnvParam } from 'env'

import { verifyOtpCode } from 'services/admin-otp'

// import WorkspaceSelector from 'components/WorkspaceSelector'

import { restLandingClient, officeNextClient } from 'myNet'

import { RSAEncDec, hashString, sendEncrypted, getDeviceUUID } from 'pUtils'

// import {
//   getMyInfo,
//   getWorkspaceInfo,
//   // getWorkspaceList
// } from './api'

// const landingParams = {
// type: 'safebox',
// schema: 'web',
// }

const prevLandingInfo = {}

const appConfigMap = {}

export function appConfig(email, forceOfficemail) {
  const promise = new Promise((resolve, reject) => {
    const info = {}

    const landingOfficeNext = () => {
      const landingType = 'officemail-migration'
      const provider = 'officenext'

      restLandingClient
        .get(`/auth/oauth/authorize/${landingType}/${provider}`, {
          login_hint: email,
        })
        .then((landingRes) => {
          const { data } = landingRes.data
          console.log('landing - ', landingType, landingRes)
          // 처리~!!
          if (data.authorization_url) {
            info.authUrl = data.authorization_url
            resolve(info)
          } else {
            reject(new Error('landing error.'))
          }
        })
    }

    if (forceOfficemail !== true) {
      restLandingClient
        .post('/provisioning/appconfig', { email })
        .then((res) => {
          console.log(' res - ', res)
          const { data } = res
          if (data.code === 200) {
            const appconfigs = data.data.appconfig
            if (appconfigs.length > 0) {
              const [appconfig] = appconfigs

              const { officenext, AppAuthenticationMethod, AppEmailServiceProvider } = appconfig

              appConfigMap[email] = appconfig

              info.officenext = officenext
              info.auth = AppAuthenticationMethod.toLowerCase()
              info.provider = AppEmailServiceProvider.toLowerCase()
              info.useOTP = false

              // appconfig 결과에 상관없이 무조건 landing을 타도록 처리.
              info.auth = 'oauth'
              landingOfficeNext()
            } else {
              reject(new Error('appconfig error.'))
            }
          } else if (data.message != null) {
            // notification.warning({
            //   message: data.code,
            //   description: data.message,
            // })
            const error = new Error(data.message)
            error.code = data.code
            reject(error)
          }
        })
        .catch((err) => {
          console.log(' err - ', err)
          reject(err)
        })
    } else {
      info.auth = 'oauth'
      landingOfficeNext()
    }
  })

  return promise
}

function setApiURL(/* appConfigData */) {
  // setEnvParam('apiURL', appConfigData.AppServiceHosts)

  // @todo 나중에는 appconfig에서 가져오도록 수정해야 함.
  if (process.env.REACT_APP_TARGET === 'production') {
    setEnvParam('apiURL', 'mail.officemail.io')
  } else {
    setEnvParam('apiURL', 'mail.officemail.app')
  }
}

const getLandingWindowSize = () => {
  return {
    width: Math.min(window.screen.availWidth, 1024),
    height: Math.min(window.screen.availHeight, 711),
  }
}

export function landingWithoutPopup(email) {
  const promise = new Promise((resolve, reject) => {
    const info = {}
    const landingType = 'officemail'
    const provider = 'officenext'

    restLandingClient
      .get(`/auth/oauth/authorize/${landingType}/${provider}`, {
        login_hint: email,
      })
      .then((landingRes) => {
        console.log('landing - ', landingType, landingRes)
        // 처리~!!
        if (landingRes.data.authorization_url) {
          info.authUrl = landingRes.data.authorization_url
          resolve(info)
        } else {
          reject(new Error('landing error.'))
        }
      })
  })

  return promise
}

const warning = (options) => {
  const props = { title: options.title, content: options.content, width: 450 }

  if (options.icon !== undefined) {
    props.icon = options.icon
  }

  return errorBase(props)
}

const clearPrevLandingEvent = () => {
  if (prevLandingInfo.clearLandingEvent != null) {
    prevLandingInfo.clearLandingEvent()
  }
}

export function openLandingPopup(smallSize) {
  // 이전에 등록된 message 이벤트를 제거한다.
  clearPrevLandingEvent()

  const windowSize = { width: 500, height: 600 }
  const windowLocation = {
    left: window.screen.availLeft + window.screen.availWidth / 2 - windowSize.width / 2,
    top: window.screen.availTop + window.screen.availHeight / 2 - windowSize.height / 2,
  }

  const options =
    smallSize !== true
      ? `width=${windowSize.width},height=${windowSize.height},left=${windowLocation.left},top=${windowLocation.top}`
      : `width=${10},height=${10},left=${windowLocation.left},top=${windowLocation.top}`

  const winName = `landingWin`

  window.loginWin = window.open('', winName, options)

  if (window.loginWin == null) {
    warning({
      title: i18n.t('common.title.blockPopup'),
      content: i18n.t('common.warning.blockPopup'),
    })

    reduxStore.dispatch({ type: 'user/LOGOUT' })

    return false
  }

  return true
}

export function closeLandingPopup() {
  try {
    if (window.loginWin != null) {
      if (window.loginTimer != null) {
        clearInterval(window.loginTimer)
      }
      window.loginWin.close()
      window.loginWin = null
    }
  } catch (err) {
    console.log(err)
  }
}

async function applyToken(jwt) {
  await store.set('app.user.token', jwt.accessToken)
  await store.set('app.user.refreshToken', jwt.refreshToken)
}

export function startLanding(email, authUrl) {
  const promise = new Promise((resolve, reject) => {
    const onSuccessLanding = (e) => {
      console.log(' -- message : ', e)

      // if (
      //   // window.location.origin === e.origin ||
      //   // (e.origin.indexOf('officemail.app') < 0 && e.origin.indexOf('officemail.io') < 0)
      // ) {
      //   return
      // }

      const data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data

      closeLandingPopup()

      if (data.params.result === 'OK') {
        console.log(' -- params : ', data.params)

        if (data.params.email !== email) {
          notification.warning({
            message: i18n.t('admin.activity.failedLogin'),
            description: i18n.t('login.desc.emailMismatch'),
          })
          return
        }

        if (data.params.email != null) {
          setEnvParam('userEmail', data.params.email)
        } else {
          setEnvParam('userEmail', email)
        }

        if (data.params.jwt.accessToken != null) {
          applyToken(data.params.jwt).then(() => {
            window.removeEventListener('message', onSuccessLanding)
            reduxStore.dispatch({
              type: 'user/LOGIN_BY_TOKEN',
              payload: {
                tokenInfo: { provider_token: data.params.officenext.accessToken },
              },
            })

            resolve(null)
          })
        } else if (data.params.verify_string != null) {
          window.removeEventListener('message', onSuccessLanding)
          resolve(data.params.verify_string)
        } else {
          authRegister(email)
            .then(() => {
              console.log('authRegister success:')
              window.removeEventListener('message', onSuccessLanding)
              reduxStore.dispatch({
                type: 'user/LOGIN_BY_TOKEN',
                payload: {
                  tokenInfo: { provider_token: data.params.jwt.accessToken },
                },
              })

              resolve(null)
            })
            .catch((err) => {
              window.removeEventListener('message', onSuccessLanding)
              reject(err)
            })
        }
      } else if (data.error != null) {
        console.log(' --- login error ', data)
        const { code, message } = data.params
        const error = new Error(message)
        error.code = code
        window.removeEventListener('message', onSuccessLanding)
        reject(error)
      } else {
        reject(new Error('message parameter error.'))
      }
    }

    window.addEventListener('message', onSuccessLanding, false)

    prevLandingInfo.clearLandingEvent = () => {
      window.removeEventListener('message', onSuccessLanding)
      prevLandingInfo.clearLandingEvent = null
    }

    try {
      const windowSize = getLandingWindowSize()
      // const windowLocation = {
      //   left: window.screen.availLeft + window.screen.availWidth / 2 - windowSize.width / 2,
      //   top: window.screen.availTop + window.screen.availHeight / 2 - windowSize.height / 2,
      // }

      // window.loginChatWin.moveTo(windowLocation.left, windowLocation.top);
      window.loginWin.resizeTo(windowSize.width, windowSize.height)
    } catch (e) {
      console.log('resize fail.', e)
    }

    window.loginWin.location.href = authUrl

    window.loginTimer = setInterval(() => {
      if (window.loginWin.closed) {
        clearInterval(window.loginTimer)

        reduxStore.dispatch({ type: 'user/LOGOUT' })
      }
    }, 1000)
  })

  return promise
}

function authRegister(email) {
  const promise = new Promise((resolve, reject) => {
    let workspaceId = null
    let authType = null
    let provider = null
    let type = null

    const appConfigData = appConfigMap[email]
    if (appConfigData != null) {
      const {
        workspace_id: configWorkspaceId,
        AppEmailServiceProvider,
        AppAuthenticationMethod,
      } = appConfigData

      workspaceId = configWorkspaceId
      authType = AppAuthenticationMethod
      provider = AppEmailServiceProvider
    } else {
      authType = 'oauth'
      provider = 'officemail'
      workspaceId = getTempEnvParam('workspaceId')
    }

    type = provider.toLowerCase()

    const deviceUUID = getDeviceUUID(email)

    const deviceModel = 'x86_64'

    let protocol = 'imap'
    switch (type) {
      case 'ms365':
        authType = 'oauth'
        protocol = 'graph' // graph or ews
        break
      case 'gmail':
        authType = 'oauth'
        protocol = 'http'
        break
      case 'imap':
        authType = 'basicauth'
        protocol = 'imap'
        break
      case 'officemail':
        authType = 'oauth'
        protocol = 'imap'
        break
      default:
        protocol = 'imap'
    }

    const providerInfo = { authType, provider, protocol }

    const params = {
      username: email, // display_name 아님. email을 사용해야 함.
      email,
      password: '',
      deviceModel,
      deviceUUID,
      appCategory: 'enterprise', // store
      workspaceId,
      // ewsURI: 'https://outlook.office365.com/EWS/Exchange.asmx',
      // authType: 'oauth',
      // provider: 'ms365',
      // protocol: 'graph', // graph or ews
      ...providerInfo,
    }
    console.log('---- authRegister - ', params)

    sendEncrypted(
      '/auth/register/web/',
      params,
      async (res) => {
        if (res.code === 200) {
          console.log('success ~~!!! ', res)

          await store.set('app.user.workspace_id', res.data.workspace_id)
          await store.set('app.user.token', res.data.pAccessToken)
          await store.set('app.user.refreshToken', res.data.pRefreshToken)

          setApiURL(appConfigData)

          resolve(true)
        } else {
          resolve(false)
        }
      },
      (ex) => {
        console.log(ex)
        notification.warning({ message: ex.code, description: ex.message })
        reject(ex)
      },
    )
  })

  return promise
}

async function loginIMAP(email, password) {
  const promise = new Promise((resolve, reject) => {
    const appConfigData = appConfigMap[email]

    const params = { email, password }

    setApiURL(appConfigData)

    if (appConfigData != null) {
      params.host = appConfigData.AppServiceHosts
      params.port = appConfigData.AppServicePort
    } else {
      const autoDiscoverRes = getEnvParam('providerInfo')
      params.host = autoDiscoverRes.incomingServer.hostname
      params.port = autoDiscoverRes.incomingServer.port
    }

    restLandingClient
      .post(`/auth/verifying/imap`, params)
      .then((res) => {
        console.log('data - ', res.data)

        if (res.data.code === 200) {
          setEnvParam('userEmail', email)

          authRegister(email)
            .then(() => {
              resolve('success')
            })
            .catch((err) => {
              reject(err)
            })
        } else if (res.data.code === 401) {
          errorBase({
            title: null,
            content: i18n.t('login.error.emailOrPwInvalid'),
          })
        } else if (res.data.code === 500 || res.data.code === 504) {
          errorBase({
            title: i18n.t('login.error.internalError'),
            content: i18n.t('login.error.retry'),
          })
          // notification.warning({
          //   message: res.data.code,
          //   description: res.data.message,
          // })
        } else {
          reject(new Error('login failed'))
        }
      })
      .catch((error) => {
        console.log('error - ', error)
        errorBase({ title: error.code, content: error.message })
        // notification.warning({
        //   message: error.code,
        //   description: error.message,
        // })
        reject(error)
      })
  })

  return promise
}

export async function login(email, password) {
  console.log(' login - ', email, password)
  if (password != null) {
    return loginIMAP(email, password)
  }

  return null
}

export async function loginByOTP(email, loginCode) {
  const promise = new Promise((resolve) => {
    verifyOtpCode(email, loginCode)
      .then((res) => {
        const { data } = res
        console.log('data - ', data)

        if (data.code === 200) {
          // token 저장하고
          if (data.workspace_id != null) {
            store.set('app.user.workspace_id', data.workspace_id)
          } else if (appConfigMap[email] != null && appConfigMap[email].workspace_id != null) {
            store.set('app.user.workspace_id', appConfigMap[email].workspace_id)
          }

          if (data.access_token != null) {
            store.set('app.user.token', data.access_token)
          }

          if (data.refresh_token != null) {
            store.set('app.user.refreshToken', data.refresh_token)
          }

          resolve(true)
        } else {
          if (data.code === 401) {
            errorBase({
              title: null,
              content: i18n.t('login.error.emailOrPwInvalid'),
            })
          } else if (data.code === 500 || data.code === 504) {
            errorBase({
              title: i18n.t('login.error.internalError'),
              content: i18n.t('login.error.retry'),
            })
          } else {
            // reject(new Error('login failed'))
            errorBase({ title: 'Error', content: 'login failed' })
          }
          resolve(false)
        }
      })
      .catch((error) => {
        console.log('error - ', error)
        errorBase({ title: error.code, content: error.message })
        // notification.warning({
        //   message: error.code,
        //   description: error.message,
        // })
        resolve(false)
      })
  })

  return promise
}

export async function loginByKey(key) {
  const promise = new Promise((resolve) => {
    restLandingClient
      .get(`/auth/login/console/${key}`)
      .then((res) => {
        const { data } = res
        console.log('data - ', data)

        if (res.data.code === 200) {
          // token 저장하고
          store.set('app.user.workspace_id', data.data.workspace_id)

          if (data.data.access_token != null) {
            store.set('app.user.token', data.data.access_token)
          }

          if (data.data.refresh_token != null) {
            store.set('app.user.refreshToken', data.data.refresh_token)
          }

          if (data.data.officenext != null) {
            // package 정보 - free, pro
            store.set('app.user.officenext', data.data.officenext)
          } else {
            store.remove('app.user.officenext')
          }

          resolve('success')
        } else {
          if (res.data.code === 401) {
            errorBase({
              title: null,
              content: i18n.t('login.error.emailOrPwInvalid'),
            })
          } else if (res.data.code === 500 || res.data.code === 504) {
            errorBase({
              title: i18n.t('login.error.internalError'),
              content: i18n.t('login.error.retry'),
            })
          } else {
            // reject(new Error('login failed'))
            errorBase({ title: 'Error', content: 'login failed' })
          }
          resolve('fail')
        }
      })
      .catch((error) => {
        console.log('error - ', error)
        errorBase({ title: error.code, content: error.message })
        // notification.warning({
        //   message: error.code,
        //   description: error.message,
        // })
        resolve('fail')
      })
  })

  return promise
}

export async function register(/* email, password, name */) {
  function fakeRegister() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, 200)
    })
  }

  return fakeRegister()
}

export function loginByToken(info) {
  const promise = new Promise((resolve) => {
    if (info.provider_token != null) {
      const userEmail = getEnvParam('userEmail')

      console.log('info - ', info)

      store.set('app.user.providerToken', info.provider_token)

      const appConfigData = appConfigMap[userEmail]

      if (appConfigData != null) {
        if (appConfigData.officenext === true) {
          // package 정보 - free, pro
          store.set('app.user.officenext', appConfigData.officenext)
        } else {
          store.remove('app.user.officenext')
        }
      } else {
        store.set('app.user.officenext', true)
      }

      setApiURL(appConfigData)
    }

    // if (info.refresh_token != null) {
    //   await localforage.setItem('app.user.refreshToken', info.refresh_token)
    // }

    resolve('success')
  })

  return promise
}

export async function umkLogin(password) {
  const reduxState = reduxStore.getState()
  const { umkDuration: duration, umkWarningDuration: warningDuration } = reduxState.settings

  const rsaObj = new RSAEncDec({
    umk: password,
    isLogin: true,
    duration,
    warningDuration,
  })

  try {
    const ret = await rsaObj.init()

    if (ret !== true) {
      errorBase({
        title: 'Error',
        content: i18n.t('login.error.noMatchingPassword'),
      })
    } else {
      setTempEnvParam('rsaObj', rsaObj)
    }

    return Promise.resolve(ret)
  } catch (e) {
    console.log(' - umkLogin error : ', e)

    // errorBase({
    //   title: 'Error',
    //   content: e.message,
    // })
    return Promise.resolve(null) // 알수 없는 오류이면 현상태 유지.
  }
}

export async function umkRegister(password) {
  console.log(' --- umkRegister : ', password)
  const reduxState = reduxStore.getState()
  const { umkDuration: duration, umkWarningDuration: warningDuration } = reduxState.settings

  try {
    const rsaObj = new RSAEncDec({
      umk: password,
      isRegister: true,
      duration,
      warningDuration,
    })

    const ret = await rsaObj.init()

    if (ret !== true) {
      errorBase({
        title: 'Error',
        content: i18n.t('login.error.noMatchingPassword'),
      })
    } else {
      setTempEnvParam('rsaObj', rsaObj)
    }

    return Promise.resolve(ret)
  } catch (e) {
    console.log(' - umkRegister error : ', e)
    // errorBase({
    //   title: 'Error',
    //   content: e.message,
    // })
    return Promise.resolve(false)
  }
}

export async function umkChangePW(password, newPassword) {
  console.log(' --- umkChangePW : ', password, newPassword)

  let rsaObj = getTempEnvParam('rsaObj')
  const authType = getTempEnvParam('authType')

  let ret = false

  const reduxState = reduxStore.getState()
  const { umkDuration: duration, umkWarningDuration: warningDuration } = reduxState.settings
  try {
    if (authType === 'change-password') {
      const base64PrivateKey = getTempEnvParam('base64privateKey')
      rsaObj = new RSAEncDec({
        umk: password,
        base64PrivateKey,
        duration,
        warningDuration,
      })
      ret = await rsaObj.changePW(newPassword, true)
    } else {
      // eslint-disable-next-line no-lonely-if
      if (rsaObj == null) {
        rsaObj = new RSAEncDec({
          umk: password,
          isLogin: true,
          duration,
          warningDuration,
        })
        ret = await rsaObj.init()

        if (ret === true) {
          ret = await rsaObj.changePW(newPassword)
        }
      } else {
        const tempRSAObj = new RSAEncDec({
          umk: password,
          isLogin: true,
          duration,
          warningDuration,
        })
        ret = await tempRSAObj.init()

        if (ret === true) {
          ret = await tempRSAObj.changePW(newPassword)

          if (ret === true) {
            rsaObj = tempRSAObj
          }
        }
      }
    }

    if (ret !== true) {
      console.log(' --- ret: ', ret)
      errorBase({ title: 'Error', content: i18n.t(`workspace.error.505`) })
    } else {
      setTempEnvParam('rsaObj', rsaObj)
    }
  } catch (e) {
    console.log(' - umkChangePW error : ', e)
    // errorBase({
    //   title: 'Error',
    //   content: e.message,
    // })
    return Promise.resolve(false)
  }

  return Promise.resolve(ret)
}

// async function loadingCheck() {
//   let checkCnt = 0
//   const promise = new Promise((resolve, reject) => {
//     const checkDB = () => {
//       if (checkCnt > 50) {
//         // 로딩에 5초이상 소요되면 reject.
//         reject(new Error('DB loading fail'))
//       }
//       if (
//         imageDB.isActive === true &&
//         messageDB.isActive === true &&
//         mainDB.isActive === true &&
//         linkPreviewDB.isActive === true
//       ) {
//         console.log(' db loading count : ', checkCnt)
//         resolve(true)
//       } else {
//         checkCnt += 1
//         setTimeout(checkDB, 100)
//       }
//     }

//     checkDB()
//   })

//   return promise
// }

export async function currentAccount() {
  const ret = hashString(')k@5+fdu6o1)clq(')

  console.log(' --- ret : ', ret)

  // const workspaceId = store.get('app.user.workspace_id')

  const token = store.get('app.user.token')

  if (token == null) {
    // 토큰이 없는 경우 로그아웃 처리.
    reduxStore.dispatch({ type: 'user/LOGOUT' })
    return null
  }

  // const myInfo = await getMyInfo()

  // let displayName = myInfo.display_name

  // orgChartData를 사용해 displayName 생성

  // if (!displayName) {
  //   const [emailUser] = myInfo.email.split('@')
  //   displayName = emailUser

  //   try {
  //     // 계정 정보 업데이트
  //     await updateAccountInfo(myInfo.id, { displayName }, null, true)
  //   } catch (error) {
  //     console.error('Failed to update account info:', error)
  //   }
  // }

  // setEnvParam('userEmail', myInfo.email)

  // let workspaceInfo = null

  // try {
  //   workspaceInfo = await getWorkspaceInfo(workspaceId)
  // } catch (e) {
  //   console.log(' - getWorkspaceInfo error : ', e)
  //   notification.error({ message: e.code, description: e.message })
  //   return null
  // }

  // console.log(' workspaceInfo - ', workspaceInfo)

  // const workspace = {
  //   id: workspaceId,
  //   workspace_name: workspaceInfo.workspaceName,
  //   workspace_email: workspaceInfo.workspaceEmail,
  //   icon_url: workspaceInfo.iconUrl,
  //   role: workspaceInfo.role,
  //   provider: workspaceInfo.provider,
  //   enableChat: workspaceInfo.enableChat,
  //   orgChartType: workspaceInfo.orgChartType,
  // }

  // setEnvParam('provider', workspaceInfo.provider)

  // if (workspace.icon_url == null) {
  //   if (workspace.workspace_name != null) {
  //     workspace.iconElem = await getInitialAvatar(
  //       workspace.workspace_name,
  //       workspace.workspace_email,
  //     )
  //   }
  // }

  // const avatarUrl = myInfo.avatar_url != null ? myInfo.avatar_url : ''

  // const authType = null

  // try {
  //   const umkRes = await migrationClient.get(`/v1/auth/info`)
  //   const { code, data } = umkRes.data
  //   console.log('umkInfo - ', code, data)
  //   if (code === 200) {
  //     authType = data.auth_type
  //     setTempEnvParam('base64privateKey', data.user_key)
  //   }
  // } catch (e) {
  //   console.log(' - getUMK error : ', e)
  // }

  // console.log(' - authType : ', authType)
  // setTempEnvParam('authType', authType)

  const email = getEnvParam('userEmail')

  return {
    id: email,
    name: email,
    email,

    // uid: '',
    // avatar: avatarUrl,
    // role: workspaceInfo.role,
    // lastLogin: '',
    // workspace,
    // authType, // : 'change-password',
  }
}

export async function logout() {
  const providerToken = store.get('app.user.providerToken')

  const officenext = store.get('app.user.officenext')
  if (officenext === true && providerToken != null) {
    const syncAniObj = openloadingAni({ text: i18n.t('logOut.desc.progress') })

    try {
      const headers = {
        Accept: 'application/json',
      }
      await officeNextClient.post('/api/logout', {}, { headers })
    } catch (e) {
      console.log('logout error', e)
    }

    syncAniObj.destroy()
  }

  await orgChartDB.clear()

  store.remove('app.user.officenext')
  store.remove('app.user.providerToken')
  store.remove('app.user.providerTokenExpiresAt')
  store.remove('app.user.connection_digest')
  store.remove('app.user.token')
  store.remove('app.user.refreshToken')
  store.remove('app.user.workspace_id')
  store.remove('app.user.refreshExpiresIn')
  store.remove('app.device.uuid')
  store.remove('app.user.registorInfo')

  removeEnvParam('provider')
  removeEnvParam('userEmail')
  removeEnvParam('appType')
  removeEnvParam('apiURL')

  return true
}

const apis = {
  // customFetch,
  login,
  logout,
}

export default apis
